import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {
  checkServiceAndGetSubscribers, setError, setSelectedSubscriber, StepsEnum, setStep, toggleCollapse, toggleData, saveToHistory, init
} from "app/Components/Block/CellularDataOnOff/CellularDataOnOffSlice";
import CollapseButton from "app/utilities/CollapseButton/CollapseButton";
import UsageBar from "app/Components/Shared/UsageBar/UsageBar";
import Skeleton from "react-loading-skeleton";
import {
  dwhCellularDataOnOffPageDisplayed,
  dwhCellularDataStatusChangeError, dwhCellularDataStatusChangeSuccess, dwhStatusChangeButtonClicked
} from "app/Components/Block/CellularDataOnOff/Reports/dwhReports";
import {getCellularReportIdentifiers} from "app/Components/Block/CellularDataOnOff/Reports/reportIdentifiers";

const ToggleStep = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const {
    selectedSubscriber,
    isCollapseOpen,
    isBlocked,
    quantity,
    used,
    quantityUnitOfMeasure,
    usedUnitOfMeasure,
    cycleRemainingDays,
    isUnlimited
  } = props.cellularDataOnOffSlice;

  const {init, setError, toggleCollapse, toggleData, saveToHistory} = props;

  const {privateSocId, businessSocId} = props.contentData;

  const {
    isOtpAuthenticated,
    isFullAuthenticated,
    isOtpExtendedAuthenticated,
    userDetails: {contactNumber, firstName, lastName, IDNumber},
  } = props.authentication.loginData;

  const subscriberNumber = selectedSubscriber.substring(0, 3) + '-' + selectedSubscriber.substring(3);

  const getReportIdentifiers = () => getCellularReportIdentifiers(
    selectedSubscriber,
    props.selfcarePage,
    props.authentication.loginData,
  );

  const handleToggleData = async () => {
    const changedBrowsingStatusTo = !isBlocked ? 'חסום' : 'פתוח';
    const loginType = isOtpAuthenticated ? 'לקוח OTP' : isFullAuthenticated ? 'לקוח בזיהוי מלא' : isOtpExtendedAuthenticated ? 'לקוח OTP מורחב' : 'Unknown';
    const sourceUrl = window.location.href;
    const customerName = `${firstName} ${lastName}`;
    const {banId, psId, cmrId} = getReportIdentifiers();
    dwhStatusChangeButtonClicked({
      subscriber: selectedSubscriber,
      changedBrowsingStatusTo,
      contact: contactNumber,
      loginType,
      sourceUrl,
      customerName,
      idNumber: IDNumber,
      banId,
      psId,
      cmrId,
    })

    const result = await toggleData(privateSocId.value);
    if (result.payload.error) {
      const browsingStatusAfterError = isBlocked ? 'חסום' : 'פתוח';
      dwhCellularDataStatusChangeError({
        subscriber: selectedSubscriber,
        browsingStatusAfterError,
        contact: contactNumber,
        loginType,
        sourceUrl,
        customerName,
        idNumber: IDNumber,
        banId,
        psId,
        cmrId,
      })
    } else {
      const browsingStatusAfterProcess = isBlocked ? 'פתוח' : 'חסום';
      dwhCellularDataStatusChangeSuccess({
        subscriber: selectedSubscriber,
        browsingStatusAfterProcess,
        contact: contactNumber,
        loginType,
        sourceUrl,
        customerName,
        idNumber: IDNumber,
        banId,
        psId,
        cmrId,
      })
    }
  }

  useEffect(() => {
    init(selectedSubscriber).then((res) => {
      if (res.error) {
        setError("שגיאה בשליפת נתונים")
      } else {
        setIsLoaded(true)
        
        const browsingStatus = isBlocked ? 'חסום' : 'פתוח';
        const loginType = isOtpAuthenticated ? 'לקוח OTP' : isFullAuthenticated ? 'לקוח בזיהוי מלא' : isOtpExtendedAuthenticated ? 'לקוח OTP מורחב' : 'Unknown';
        const sourceUrl = window.location.href;
        const customerName = `${firstName} ${lastName}`;
        const {banId, psId, cmrId} = getReportIdentifiers();
        dwhCellularDataOnOffPageDisplayed({
          subscriber: selectedSubscriber,
          browsingStatus,
          contact: contactNumber,
          loginType,
          sourceUrl,
          customerName,
          idNumber: IDNumber,
          banId,
          psId,
          cmrId,
        })
      }
    });
    saveToHistory("toggle");
  }, []);

  return (
    <div className={'toggle-step-container'}>
      <div className={'title-container'}>
        <span className={'title'}>
          {props.contentData?.title?.value}
        </span>
        <span className={'subTitle'}>{subscriberNumber}</span>
      </div>
      {
        isLoaded ? (
          <div className='toggle-container'>
            <Image className='wifi-icon'
              src={require(!isBlocked ? './../../Images/dataOn.svg' : './../../Images/dataOff.svg')}
              alt='wifi' />
            <div className='switch-container'>
              <div className='switch'>
                <div
                  className={!isBlocked ? 'selected' : 'unselected'}
                  onClick={isBlocked ? handleToggleData : null}
                >
                  {!isBlocked ? "גלישה פתוחה" : "פתיחת גלישה"}
                </div>
                <div
                  className={!isBlocked ? 'unselected' : 'selected'}
                  onClick={!isBlocked ? handleToggleData : null}
                >
                  {!isBlocked ? "חסימת גלישה" : "גלישה חסומה"}
                </div>
              </div>
              <span
                className='info'
                dangerouslySetInnerHTML={{__html: props.contentData?.toggleInfo?.value}}
              ></span>
            </div>
          </div>
        ) : (
          <Skeleton height="337px" width="100%" className="skeleton"/>
        )
      }

      <div className={'data-usage-container'}>
        {isLoaded ?
          <CollapseButton
            cardTitle={'מידע על ניצול גלישה'}
            setIsOpen={() => toggleCollapse()}
            isOpen={isCollapseOpen}
          />
          :
          <Skeleton height={"100%"} width={"100%"}/>
        }
        {isCollapseOpen && (
          <div className="data-usage">
            <div className="divider"></div>
            {isUnlimited ? (
              <span className="unlimited grayText usage_item">
                ניצלת <span className="used">{used}{usedUnitOfMeasure}</span> מתוך חבילת הגלישה שלך
              </span>
            ) : (
              <UsageBar
                title="גלישה חודשית"
                usedQuantity={used}
                maxUsageQuantity={quantity}
                statusBarWidth={(used / quantity) * 100}
                cycleRemainingDays={cycleRemainingDays}
                usedUnitOfMeasure={usedUnitOfMeasure}
                quantityUnitOfMeasure={quantityUnitOfMeasure}
                extraLinkText="להרחבת גלישה >"
                extraLinkLink={props.contentData?.updatePaymentMethod?.value}
                moreInfoText="מידע נוסף >"
                moreInfoLink={props.contentData?.moreInfoLink?.value}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cellularDataOnOffSlice: state.cellularDataOnOffSlice,
    authentication: state.authentication,
    selfcarePage: state.selfcarePage,
  };
};

const mapDispatchToProps = {
  setSelectedSubscriber,
  checkServiceAndGetSubscribers,
  setError,
  setStep,
  toggleCollapse,
  toggleData,
  saveToHistory,
  init
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleStep);
